(() => {
  if (window.taffstyleCollectionCardsReady) return;
  window.taffstyleCollectionCardsReady = true;
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.ts-collection .ts-colors-toggle');
    if (!button) return;
    const colors = button.closest('.ts-card-colors');
    const expanded = button.getAttribute('aria-expanded') !== 'true';
    colors.classList.toggle('ts-colors-expanded', expanded);
    button.setAttribute('aria-expanded', String(expanded));
    button.textContent = expanded ? button.dataset.less : button.dataset.more;
  }, true);
})();
